import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';

import { AsyncPipe, CommonModule, NgFor, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ShActionItemComponent } from '../../../../elements/components/action-item/action-item.component';
import { MakeProvider } from '../../../../helpers/base-control-value-accessor';
import { FormValue, FormValueState } from '../../../entities/form-value.entity';
import { ShAutocompleteComponent } from '../../_core/autocomplete/autocomplete.component';
import { ShFormNumberInputComponent } from '../../form-number/main/form-number.component';
import { ShFormListComplexBaseComponent } from '../base-complex/form-list-complex-base.component';

@Component({
    selector: 'sh-form-list-base',
    templateUrl: '../base-complex/form-list-complex-base.component.html',
    styleUrls: ['../base-complex/form-list-complex-base.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(ShFormListBaseComponent)],
    standalone: true,
    imports: [
        ReactiveFormsModule,
        NgFor,
        NgIf,
        ShAutocompleteComponent,
        ShFormNumberInputComponent,
        ShActionItemComponent,
        AsyncPipe,
        TranslateModule,
        CommonModule
    ]
})
export class ShFormListBaseComponent extends ShFormListComplexBaseComponent {
    constructor(
        ref: ChangeDetectorRef,
        protected formBuilder: UntypedFormBuilder
    ) {
        super(ref, formBuilder);
    }

    propagateChange(formValues: FormValue<string>[]): void {
        const unwrapped: string[] = formValues
            .filter(formValue => formValue.state === FormValueState.SET)
            .map(formValue => FormValue.unwrap(formValue));
        super.propagateChange(unwrapped as any);
    }

    writeValue(values: string[]): void {
        if (values instanceof Array === false) {
            super.writeValue([]);
            return;
        }
        const converted: FormValue<string>[] = values.map(value => FormValue.wrap(value));
        super.writeValue(converted);
    }
}
